import classNames from 'classnames';
import { Avatar } from 'ui';
import { User } from 'compliance-api';

interface UsersAvatarsSetProps {
  onClick?: (user: User) => void;
  users: User[] | undefined;
  className?: string;
}

const UsersAvatarsSet = ({ users, className, onClick }: UsersAvatarsSetProps) => {
  return (
    <div className={classNames('col-start-11 col-span-2 relative z-0 w-[100px]', className)}>
      <div className="flex justify-end -space-x-1.5">
        {users && users.length > 0 && (
          <div className="z-20 flex items-center justify-center overflow-hidden">
            <Avatar
              onClick={onClick && onClick.bind(null, users[0])}
              src={users[0].avatar_url}
              firstName={users[0].first_name}
              lastName={users[0].last_name}
              className="border border-white"
            />
          </div>
        )}
        {users && users.length >= 2 && (
          <div className=" z-10 flex items-center justify-center overflow-hidden">
            <Avatar
              onClick={onClick && onClick.bind(null, users[1])}
              src={users[1].avatar_url}
              firstName={users[1].first_name}
              lastName={users[1].last_name}
              className="border border-white"
            />
          </div>
        )}

        {users && users.length > 2 && (
          <div className="text-[14px] text-gray-600 bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center">
            +{users.length - 2}
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersAvatarsSet;
